export default "__VITE_PUBLIC_ASSET__9ccf8a07__"